import { GlobalStore } from "store/global/GlobalStore";
import { Network, NetworkName } from "types/network";
import { arbitrum, mainnet, polygon } from "viem/chains";
import { ArbitrumIcon, EthereumIcon, PolygonIcon } from "components/Icons";
import React, { SVGProps } from "react";

export interface NetworkConfig {
  networkIconColor: string;
  icon: React.FC<SVGProps<SVGSVGElement>>;
  name: Network["name"];
  id: Network["chainId"];
}

export const useNetworkConfig = (): Record<Network["chainId"], NetworkConfig> => {
  const theme = GlobalStore.useState(s => s.theme);
  return {
    [mainnet.id]: {
      networkIconColor: theme.Networks.Ethereum,
      icon: EthereumIcon,
      name: NetworkName.ETHEREUM,
      id: mainnet.id,
    },
    [polygon.id]: {
      networkIconColor: theme.Networks.Polygon,
      icon: PolygonIcon,
      name: NetworkName.POLYGON,
      id: polygon.id,
    },
    [arbitrum.id]: {
      networkIconColor: theme.Networks.Arbitrum,
      icon: ArbitrumIcon,
      name: NetworkName.ARBITRUM,
      id: arbitrum.id,
    },
  };
};
